import Vue from 'vue'
import router from '@/router'

/**
 * 全局页面跳转 loading（独立于组件树的响应式 store）。
 * 不挂在 $root 上：main.js 的 new Vue 外层根实例与 App.vue 组件实例不是同一个，
 * 页面组件 this.$root 拿不到 App.vue 的 methods。
 * 用 new Vue({data}) 做响应式状态，Vue 2.5/2.6/2.7 均兼容。
 */
export const loadingState = new Vue({
  data: { visible: false }
})

let hideTimer = null

export function showLoading() {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
  loadingState.visible = true
}

export function hideLoading() {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
  loadingState.visible = false
}

/**
 * 带全局 loading 的路由跳转：APK WebView 新页面首帧渲染有延迟，
 * 跳转期间显示遮罩，路由完成后再保留 holdMs 覆盖渲染期，随后自动关闭。
 * @param {string|Object} route 路由目标
 * @param {number} holdMs 路由完成后 loading 保留时长（ms），默认 600；首页/我的模块跳转传 2000 即显示约 2s
 */
export function navigateWithLoading(route, holdMs) {
  if (loadingState.visible) return
  showLoading()
  let done = false
  const finish = () => {
    if (done) return
    done = true
    hideTimer = setTimeout(hideLoading, holdMs != null ? holdMs : 600)
  }
  try {
    const ret = router.push(route)
    if (ret && typeof ret.then === 'function') {
      ret.then(finish, finish)
    } else {
      finish()
    }
  } catch (e) {
    hideLoading()
  }
}



// WEBPACK FOOTER //
// ./src/utils/loading.js